<div class="page-content" [class.drawer-content]="drawerMode">
  <div class="page_header" *ngIf="!drawerMode">
    <div class="page_header_text">
      <app-back-button></app-back-button>
      <div class="page_header_title_block">
        <h1>{{ editMode ? "Editar Equipamento" : "Novo Equipamento" }}</h1>
        <span>{{
          editMode
          ? "Actualizar dados do equipamento"
          : "Registar novo equipamento no sistema"
          }}</span>
      </div>
    </div>
  </div>

  <div class="form-page-card">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">

      <!-- TEMPLATE DYNAMIC PROP -->
      <ng-template #dynamicProp let-item="item">
        <div class="sp-form-group prop-field">
          <label>
            <i [class]="item.ctrl.get('icon')?.value || 'pi pi-list'"></i>
            <span [ngSwitch]="item.ctrl.get('nome')?.value">
              <ng-container *ngSwitchCase="'NUMERO_SERIE'">Nº de Série</ng-container>
              <ng-container *ngSwitchCase="'TIPO'">Tipo</ng-container>
              <ng-container *ngSwitchCase="'MARCA'">Marca</ng-container>
              <ng-container *ngSwitchCase="'MODELO'">Modelo</ng-container>
              <ng-container *ngSwitchCase="'CALIBRE'">Calibre</ng-container>
              <ng-container *ngSwitchCase="'PAIS_ORIGEM'">País de Origem</ng-container>
              <ng-container *ngSwitchCase="'ANO_FABRICO'">Ano de Fabrico</ng-container>
              <ng-container *ngSwitchCase="'COR_ACABAMENTO'">Cor/Acabamento</ng-container>
              <ng-container *ngSwitchCase="'CAPACIDADE_MUNICOES'">Capacidade de Munições</ng-container>
              <ng-container *ngSwitchCase="'NUMERO_LICENCA'">Nº de Licença</ng-container>
              <ng-container *ngSwitchCase="'DATA_EMISSAO_LICENCA'">Data de Emissão da Licença</ng-container>
              <ng-container *ngSwitchCase="'VALIDADE_LICENCA'">Validade da Licença</ng-container>
              <ng-container *ngSwitchCase="'ENTIDADE_EMISSORA'">Entidade Emissora</ng-container>
              <ng-container *ngSwitchCase="'CATEGORIA_EQUIPAMENTO_ARMA'">Categoria</ng-container>
              <ng-container *ngSwitchCase="'GUARDA_RESPONSAVEL'">Guarda Responsável</ng-container>
              <ng-container *ngSwitchCase="'DATA_ULTIMA_VERIFICACAO'">Data da Última Verificação</ng-container>
              <ng-container *ngSwitchCase="'FREQUENCIA_VERIFICACAO'">Frequência de Verificação</ng-container>
              <ng-container *ngSwitchCase="'PROXIMA_VERIFICACAO_OBRIGATORIA'">Próxima Verificação</ng-container>
              <ng-container *ngSwitchDefault>{{ getCampoLabel(item) }}</ng-container>
            </span>
          </label>
          <ng-container *ngIf="item.ctrl.get('sourceKey')?.value; else campoSimples">
            <div class="dynamic-select-row">
              <p-select
                [formControl]="getPropertyValueControl(item)"
                [options]="propOptions[item.index]"
                optionLabel="label"
                optionValue="value"
                [filter]="(propOptions[item.index]?.length ?? 0) > 8"
                [loading]="propOptionsLoading[item.index]"
                [disabled]="propDropdownDisabled[item.index]"
                [placeholder]="
                  propDropdownDisabled[item.index]
                    ? 'Seleccione o campo anterior primeiro'
                    : 'Seleccionar'
                "
                appendTo="body"
                styleClass="w-full"
              />
              <app-quick-create-option
                *ngIf="canCreateDynamicOption(item.ctrl.get('sourceKey')?.value)"
                [sourceKey]="item.ctrl.get('sourceKey')?.value"
                [optionName]="item.ctrl.get('sourceKey')?.value === 'PROPRIEDADE_OPCOES' ? getCampoLabel(item) : ''"
                [dependValue]="getCreateDependValue(item.index, item.ctrl.get('sourceKey')?.value)"
                [existingOptions]="propOptions[item.index]"
                [disabled]="
                  propDropdownDisabled[item.index] ||
                  getCreateDependValue(item.index, item.ctrl.get('sourceKey')?.value) == null
                "
                (optionCreated)="onDynamicOptionCreated(item.index, $event)"
              />
            </div>
          </ng-container>

          <ng-template #campoSimples>
            <ng-container [ngSwitch]="item.ctrl.get('tipoDado')?.value">
              <p-inputnumber *ngSwitchCase="2" [formControl]="getPropertyValueControl(item)" [minFractionDigits]="0"
                [maxFractionDigits]="2" styleClass="w-full" />
              <p-datepicker *ngSwitchCase="4" [formControl]="getPropertyValueControl(item)" dateFormat="dd/mm/yy" [showIcon]="true"
                appendTo="body" [baseZIndex]="1000010" styleClass="w-full" [autoZIndex]="true" panelStyleClass="drawer-datepicker-panel" />
              <input *ngSwitchDefault pInputText [formControl]="getPropertyValueControl(item)" class="w-full" />
            </ng-container>
          </ng-template>
        </div>
      </ng-template>

      <!-- ═══════════════════════════════════════════════════════════════════
           1. FOTO DO EQUIPAMENTO (não para Arma — foto integrada na Seção 1)
           ═══════════════════════════════════════════════════════════════════ -->
      <section class="form-section" *ngIf="!isArma">
        <div class="form-section-header">
          <i class="ri-image-line"></i> Foto do Equipamento
        </div>
        <div class="foto-body">
          <div class="foto-preview" (click)="fotoInput.click()">
            <app-equipment-photo
              *ngIf="fotoPreviewUrl"
              [src]="fotoPreviewUrl"
              alt="Foto do equipamento"
              fallbackIcon="ri-image-add-line"
              fallbackLabel="Imagem indisponível"
            />
            <div *ngIf="!fotoPreviewUrl" class="foto-placeholder">
              <i class="ri-image-add-line"></i>
              <span>Clique para adicionar</span>
            </div>
          </div>
          <input #fotoInput type="file" accept="image/*" hidden (change)="onFotoSelect($event)" />
          <div class="foto-hint">
            <p class="foto-hint__desc">
              JPG ou PNG · recomendado 400 × 400 px · máx. 5 MB
            </p>
            <div class="foto-hint__actions">
              <button type="button" class="foto-hint__btn" (click)="fotoInput.click()">
                <i class="ri-upload-cloud-line"></i>
                {{ fotoPreviewUrl ? "Substituir foto" : "Escolher ficheiro" }}
              </button>
              <button *ngIf="fotoPreviewUrl" type="button" class="btn-link danger sm" (click)="removeFoto()">
                <i class="ri-delete-bin-line"></i> Remover
              </button>
            </div>
          </div>
        </div>
      </section>

      <!-- ═══════════════════════════════════════════════════════════════════
           2. IDENTIFICAÇÃO
           ═══════════════════════════════════════════════════════════════════ -->
      <section class="form-section" *ngIf="!isArma">
        <div class="form-section-header">
          <i class="ri-qr-code-line"></i> Identificação
        </div>
        <div class="form-grid">
          <div class="sp-form-group">
            <label>Tipo de Equipamento <span class="req">*</span></label>
            <p-select
              formControlName="idTipoEquipamento"
              [options]="tiposEquipamento"
              optionLabel="designacao"
              optionValue="id"
              placeholder="Seleccionar tipo"
              [loading]="loadingDropdowns"
              styleClass="w-full"
              (onChange)="onTipoEquipamentoChange($event.value)"
            />
            <small class="form-error" *ngIf="form.get('idTipoEquipamento')?.invalid && form.get('idTipoEquipamento')?.touched">
              Obrigatório
            </small>
          </div>

          <ng-container *ngIf="isViatura">
            <ng-container *ngFor="let item of getPropsForGroup(['ESTADO_INICIAL']); trackBy: trackByPropertyIndex">
              <ng-container *ngTemplateOutlet="dynamicProp; context: { item: item }"></ng-container>
            </ng-container>
          </ng-container>
        </div>

        <!-- Campos específicos de viatura (só para Viatura) -->
        <div class="form-grid" *ngIf="isViatura && form.get('idTipoEquipamento')?.value != null">
          <div class="attach-empty" style="grid-column: 1 / -1;" *ngIf="loadingPropriedades">
            <i class="pi pi-spin pi-spinner"></i>
            <span>A carregar campos...</span>
          </div>
          <ng-container *ngIf="!loadingPropriedades">
            <ng-container *ngFor="let item of getPropsForGroup(viaturaProps.identificacao); trackBy: trackByPropertyIndex">
              <ng-container *ngTemplateOutlet="dynamicProp; context: { item: item }"></ng-container>
            </ng-container>
          </ng-container>
        </div>
      </section>

      <!-- Empty state: tipo não seleccionado -->
      <div class="attach-empty prop-empty" *ngIf="form.get('idTipoEquipamento')?.value == null && !loadingPropriedades">
        <i class="ri-list-settings-line"></i>
        <span>Selecione o tipo de equipamento para ver os campos específicos</span>
      </div>

      <!-- ═══════════════════════════════════════════════════════════════════════════
           ARMA: Secções específicas (5 blocos)
           ═══════════════════════════════════════════════════════════════════════════ -->

      <!-- SEÇÃO 1: Identificação da Arma -->
      <section class="form-section" *ngIf="isArma && form.get('idTipoEquipamento')?.value != null">
        <div class="form-section-header">
          <i class="ri-shield-line"></i> Identificação da Arma
        </div>
        <p class="form-section-description">Características físicas e identificação principal da arma.</p>

        <div class="foto-body">
          <div class="foto-preview" (click)="armaFotoInput.click()">
            <app-equipment-photo
              *ngIf="fotoPreviewUrl"
              [src]="fotoPreviewUrl"
              alt="Foto do equipamento"
              fallbackIcon="ri-image-add-line"
              fallbackLabel="Imagem indisponível"
            />
            <div *ngIf="!fotoPreviewUrl" class="foto-placeholder">
              <i class="ri-image-add-line"></i>
              <span>Clique para adicionar</span>
            </div>
          </div>
          <input #armaFotoInput type="file" accept="image/*" hidden (change)="onFotoSelect($event)" />
          <div class="foto-hint">
            <p class="foto-hint__desc">
              JPG ou PNG · recomendado 400 × 400 px · máx. 5 MB
            </p>
            <div class="foto-hint__actions">
              <button type="button" class="foto-hint__btn" (click)="armaFotoInput.click()">
                <i class="ri-upload-cloud-line"></i>
                {{ fotoPreviewUrl ? "Substituir foto" : "Escolher ficheiro" }}
              </button>
              <button *ngIf="fotoPreviewUrl" type="button" class="btn-link danger sm" (click)="removeFoto()">
                <i class="ri-delete-bin-line"></i> Remover
              </button>
            </div>
          </div>
        </div>

        <div class="form-grid">
          <div class="attach-empty" style="grid-column: 1 / -1;" *ngIf="loadingPropriedades">
            <i class="pi pi-spin pi-spinner"></i>
            <span>A carregar campos...</span>
          </div>
          <ng-container *ngIf="!loadingPropriedades">
            <ng-container *ngFor="let item of getPropsForGroup(['NUMERO_SERIE']); trackBy: trackByPropertyIndex">
              <ng-container *ngTemplateOutlet="dynamicProp; context: { item: item }"></ng-container>
            </ng-container>
            <ng-container *ngFor="let item of getPropsForGroup(['TIPO']); trackBy: trackByPropertyIndex">
              <ng-container *ngTemplateOutlet="dynamicProp; context: { item: item }"></ng-container>
            </ng-container>
            <div class="sp-form-group">
              <label>Estado Inicial <span class="req">*</span></label>
              <p-select
                formControlName="estado"
                [options]="estados"
                optionLabel="label"
                optionValue="value"
                placeholder="Seleccionar estado"
                styleClass="w-full"
              />
            </div>
            <ng-container *ngFor="let item of getPropsForGroup(['MARCA']); trackBy: trackByPropertyIndex">
              <ng-container *ngTemplateOutlet="dynamicProp; context: { item: item }"></ng-container>
            </ng-container>
            <ng-container *ngFor="let item of getPropsForGroup(['MODELO']); trackBy: trackByPropertyIndex">
              <ng-container *ngTemplateOutlet="dynamicProp; context: { item: item }"></ng-container>
            </ng-container>
            <ng-container *ngFor="let item of getPropsForGroup(['CALIBRE']); trackBy: trackByPropertyIndex">
              <ng-container *ngTemplateOutlet="dynamicProp; context: { item: item }"></ng-container>
            </ng-container>
            <ng-container *ngFor="let item of getPropsForGroup(['PAIS_ORIGEM']); trackBy: trackByPropertyIndex">
              <ng-container *ngTemplateOutlet="dynamicProp; context: { item: item }"></ng-container>
            </ng-container>
            <ng-container *ngFor="let item of getPropsForGroup(['ANO_FABRICO']); trackBy: trackByPropertyIndex">
              <ng-container *ngTemplateOutlet="dynamicProp; context: { item: item }"></ng-container>
            </ng-container>
            <ng-container *ngFor="let item of getPropsForGroup(['COR_ACABAMENTO']); trackBy: trackByPropertyIndex">
              <ng-container *ngTemplateOutlet="dynamicProp; context: { item: item }"></ng-container>
            </ng-container>
            <ng-container *ngFor="let item of getPropsForGroup(['CAPACIDADE_MUNICOES']); trackBy: trackByPropertyIndex">
              <ng-container *ngTemplateOutlet="dynamicProp; context: { item: item }"></ng-container>
            </ng-container>
          </ng-container>
        </div>
      </section>

      <!-- SEÇÃO 2: Documentação Legal -->
      <section class="form-section" *ngIf="isArma && form.get('idTipoEquipamento')?.value != null">
        <div class="form-section-header">
          <i class="ri-file-shield-line"></i> Documentação Legal
        </div>
        <p class="form-section-description">Dados da licença e da aquisição da arma.</p>
        <div class="form-grid">
          <ng-container *ngIf="!loadingPropriedades">
            <ng-container *ngFor="let item of getPropsForGroup(['NUMERO_LICENCA']); trackBy: trackByPropertyIndex">
              <ng-container *ngTemplateOutlet="dynamicProp; context: { item: item }"></ng-container>
            </ng-container>
            <ng-container *ngFor="let item of getPropsForGroup(['DATA_EMISSAO_LICENCA']); trackBy: trackByPropertyIndex">
              <ng-container *ngTemplateOutlet="dynamicProp; context: { item: item }"></ng-container>
            </ng-container>
            <ng-container *ngFor="let item of getPropsForGroup(['VALIDADE_LICENCA']); trackBy: trackByPropertyIndex">
              <ng-container *ngTemplateOutlet="dynamicProp; context: { item: item }"></ng-container>
            </ng-container>
            <ng-container *ngFor="let item of getPropsForGroup(['ENTIDADE_EMISSORA']); trackBy: trackByPropertyIndex">
              <ng-container *ngTemplateOutlet="dynamicProp; context: { item: item }"></ng-container>
            </ng-container>
          </ng-container>
          <div class="sp-form-group">
            <label>Data de Aquisição</label>
            <p-datepicker formControlName="dataAquisicao" dateFormat="dd/mm/yy" [showIcon]="true" [maxDate]="today"
              appendTo="body" [baseZIndex]="1000010" styleClass="w-full" [autoZIndex]="true" panelStyleClass="drawer-datepicker-panel" />
          </div>
          <div class="sp-form-group">
            <label>Valor de Aquisição (AOA)</label>
            <p-inputnumber formControlName="valorAquisicao" [minFractionDigits]="0" [maxFractionDigits]="0"
              styleClass="w-full" placeholder="0" />
          </div>
        </div>
      </section>

      <!-- SEÇÃO 3: Atribuição e Operação -->
      <section class="form-section" *ngIf="isArma && form.get('idTipoEquipamento')?.value != null">
        <div class="form-section-header">
          <i class="ri-steering-fill"></i> Atribuição e Operação
        </div>
        <p class="form-section-description">Responsabilidade, posto atribuído e calendário de verificações.</p>
        <div class="form-grid">
          <ng-container *ngIf="!loadingPropriedades">
            <ng-container *ngFor="let item of getPropsForGroup(['CATEGORIA_EQUIPAMENTO_ARMA']); trackBy: trackByPropertyIndex">
              <ng-container *ngTemplateOutlet="dynamicProp; context: { item: item }"></ng-container>
            </ng-container>
          </ng-container>
          <div class="sp-form-group col-span-2">
            <label>Posto Atribuído</label>
            <p-select formControlName="idPosto" [options]="postos" optionLabel="nome" optionValue="id"
              (onChange)="onPostoSelecionado($event)" placeholder="Nenhum posto atribuído" [filter]="true" [showClear]="true" appendTo="body" styleClass="w-full" />
          </div>
          <div class="attach-empty" style="grid-column: 1 / -1;" *ngIf="loadingPropriedades">
            <i class="pi pi-spin pi-spinner"></i>
            <span>A carregar campos...</span>
          </div>
          <ng-container *ngIf="!loadingPropriedades">
            <ng-container *ngFor="let item of getPropsForGroup(['GUARDA_RESPONSAVEL']); trackBy: trackByPropertyIndex">
              <ng-container *ngTemplateOutlet="dynamicProp; context: { item: item }"></ng-container>
            </ng-container>
            <ng-container *ngFor="let item of getPropsForGroup(['DATA_ULTIMA_VERIFICACAO']); trackBy: trackByPropertyIndex">
              <ng-container *ngTemplateOutlet="dynamicProp; context: { item: item }"></ng-container>
            </ng-container>
            <ng-container *ngFor="let item of getPropsForGroup(['FREQUENCIA_VERIFICACAO']); trackBy: trackByPropertyIndex">
              <ng-container *ngTemplateOutlet="dynamicProp; context: { item: item }"></ng-container>
            </ng-container>
            <ng-container *ngFor="let item of getPropsForGroup(['PROXIMA_VERIFICACAO_OBRIGATORIA']); trackBy: trackByPropertyIndex">
              <ng-container *ngTemplateOutlet="dynamicProp; context: { item: item }"></ng-container>
            </ng-container>
          </ng-container>
        </div>
      </section>

      <!-- UTENSÍLIO: secções específicas -->
      <section class="form-section" *ngIf="!isViatura && !isArma && form.get('idTipoEquipamento')?.value != null">
        <div class="form-section-header">
          <i class="ri-settings-3-line"></i> Dados do Utensílio
        </div>
        <div class="form-grid">
          <ng-container *ngFor="let item of getPropsForGroup(utensilioProps.dados); trackBy: trackByPropertyIndex">
            <ng-container *ngTemplateOutlet="dynamicProp; context: { item: item }"></ng-container>
          </ng-container>
          <div class="sp-form-group" *ngIf="!loadingPropriedades && !hasDynamicProperty('MARCA')">
            <label>Marca</label>
            <div class="dynamic-select-row">
              <p-select formControlName="marcaUtensilio" [options]="marcasUtensilio" optionLabel="label"
                optionValue="value" [loading]="loadingMarcasUtensilio" [filter]="true"
                placeholder="Seleccionar marca" (onChange)="onMarcaUtensilioChange($event)"
                appendTo="body" styleClass="w-full" />
              <app-quick-create-option sourceKey="MARCAS_UTENSILIO" [dependValue]="3"
                [existingOptions]="marcasUtensilio" [disabled]="loadingMarcasUtensilio"
                (optionCreated)="onMarcaUtensilioCriada($event)" />
            </div>
          </div>
          <div class="sp-form-group" *ngIf="!loadingPropriedades && !hasDynamicProperty('MODELO')">
            <label>Modelo</label>
            <div class="dynamic-select-row">
              <p-select formControlName="modeloUtensilio" [options]="modelosUtensilio" optionLabel="label"
                optionValue="value" [loading]="loadingModelosUtensilio"
                [disabled]="!form.get('marcaUtensilio')?.value" [filter]="true"
                placeholder="Seleccionar modelo" appendTo="body" styleClass="w-full" />
              <app-quick-create-option sourceKey="MODELOS_POR_MARCA"
                [dependValue]="form.get('marcaUtensilio')?.value"
                [existingOptions]="modelosUtensilio" [disabled]="!form.get('marcaUtensilio')?.value || loadingModelosUtensilio"
                (optionCreated)="onModeloUtensilioCriado($event)" />
            </div>
          </div>
        </div>
      </section>

      <section class="form-section" *ngIf="!isViatura && !isArma && form.get('idTipoEquipamento')?.value != null">
        <div class="form-section-header">
          <i class="ri-speed-line"></i> Resumo Operacional
        </div>
        <div class="form-grid">
          <div class="sp-form-group">
            <label>Estado <span class="req">*</span></label>
            <p-select formControlName="estado" [options]="estados" optionLabel="label" optionValue="value"
              placeholder="Seleccionar estado" styleClass="w-full" />
          </div>
          <div class="sp-form-group">
            <label>Disponibilidade</label>
            <input pInputText value="Activo" readonly class="w-full" />
          </div>
          <div class="sp-form-group col-span-2">
            <label>Posto Atribuído</label>
            <p-select formControlName="idPosto" [options]="postos" optionLabel="nome" optionValue="id"
              (onChange)="onPostoSelecionado($event)" placeholder="Nenhum posto atribuído" [filter]="true" [showClear]="true" appendTo="body" styleClass="w-full" />
          </div>
          <ng-container *ngFor="let item of getPropsForGroup(utensilioProps.resumo); trackBy: trackByPropertyIndex">
            <ng-container *ngTemplateOutlet="dynamicProp; context: { item: item }"></ng-container>
          </ng-container>
        </div>
      </section>

      <section class="form-section" *ngIf="!isViatura && !isArma && form.get('idTipoEquipamento')?.value != null">
        <div class="form-section-header">
          <i class="ri-file-list-3-line"></i> Dados Administrativos
        </div>
        <div class="form-grid">
          <ng-container *ngFor="let item of getPropsForGroup(utensilioProps.administrativos); trackBy: trackByPropertyIndex">
            <ng-container *ngTemplateOutlet="dynamicProp; context: { item: item }"></ng-container>
          </ng-container>
          <div class="sp-form-group">
            <label>Data de Aquisição</label>
            <p-datepicker formControlName="dataAquisicao" dateFormat="dd/mm/yy" [showIcon]="true" [maxDate]="today"
              appendTo="body" [baseZIndex]="1000010" styleClass="w-full" [autoZIndex]="true" panelStyleClass="drawer-datepicker-panel" />
          </div>
          <div class="sp-form-group">
            <label>Valor de Aquisição (AOA)</label>
            <p-inputnumber formControlName="valorAquisicao" [minFractionDigits]="0" [maxFractionDigits]="0"
              styleClass="w-full" placeholder="0" />
          </div>
        </div>
      </section>

      <section class="form-section" *ngIf="isUtensilio">
        <div class="form-section-header">
          <i class="ri-sticky-note-line"></i> Observações
        </div>
        <div class="form-grid">
          <div class="sp-form-group col-span-2">
            <label>Observação</label>
            <textarea pTextarea formControlName="observacoes" aria-label="Observação"
              placeholder="Notas adicionais sobre o utensílio..." rows="4" class="w-full"></textarea>
          </div>
        </div>
      </section>

      <!-- ═══════════════════════════════════════════════════════════════════
           3. ATRIBUIÇÃO E OPERAÇÃO (não para Arma — campos redistribuídos)
           ═══════════════════════════════════════════════════════════════════ -->
      <section class="form-section" *ngIf="isViatura">
        <div class="form-section-header">
          <i class="ri-steering-fill"></i> Atribuição e Operação
        </div>
        <div class="form-grid">
          <div class="sp-form-group">
            <label>Data de Aquisição</label>
            <p-datepicker formControlName="dataAquisicao" dateFormat="dd/mm/yy" [showIcon]="true" [maxDate]="today"
              appendTo="body" [baseZIndex]="1000010" styleClass="w-full" [autoZIndex]="true" panelStyleClass="drawer-datepicker-panel" />
          </div>
          <div class="sp-form-group">
            <label>Valor de Aquisição (AOA)</label>
            <p-inputnumber formControlName="valorAquisicao" [minFractionDigits]="0" [maxFractionDigits]="0"
              styleClass="w-full" placeholder="0" />
          </div>
          <div class="sp-form-group col-span-2">
            <label>Posto Atribuído</label>
            <p-select formControlName="idPosto" [options]="postos" optionLabel="nome" optionValue="id"
              (onChange)="onPostoSelecionado($event)" placeholder="Nenhum posto atribuído" [filter]="true" [showClear]="true" appendTo="body" styleClass="w-full" />
          </div>
        </div>
      </section>

      <!-- ═══════════════════════════════════════════════════════════════════
           4. MANUTENÇÃO E REVISÃO (só Viatura)
           ═══════════════════════════════════════════════════════════════════ -->
      <section class="form-section" *ngIf="isViatura">
        <div class="form-section-header">
          <i class="ri-tools-line"></i> Manutenção e Revisão
        </div>
        <div class="form-grid">
          <ng-container *ngFor="let item of getPropsForGroup(viaturaProps.manutencao); trackBy: trackByPropertyIndex">
            <ng-container *ngTemplateOutlet="dynamicProp; context: { item: item }"></ng-container>
          </ng-container>
        </div>
      </section>

      <!-- ═══════════════════════════════════════════════════════════════════
           5. SEGURO — opcional (só Viatura)
           ═══════════════════════════════════════════════════════════════════ -->
      <section class="form-section" *ngIf="isViatura">
        <div class="form-section-header">
          <i class="ri-shield-check-line"></i> Seguro
          <span class="opt-label">(opcional)</span>
        </div>
        <div class="form-grid">
          <ng-container *ngFor="let item of getPropsForGroup(viaturaProps.seguro); trackBy: trackByPropertyIndex">
            <ng-container *ngTemplateOutlet="dynamicProp; context: { item: item }"></ng-container>
          </ng-container>
        </div>
      </section>

      <!-- ═══════════════════════════════════════════════════════════════════
           6. RESPONSÁVEL E CLASSIFICAÇÃO INTERNA
           ═══════════════════════════════════════════════════════════════════ -->
      <section class="form-section" *ngIf="isViatura">
        <div class="form-section-header">
          <i class="ri-user-star-line"></i> Responsável e Classificação Interna
        </div>
        <div class="form-grid">
          <ng-container *ngFor="let item of getPropsForGroup(viaturaProps.responsavel); trackBy: trackByPropertyIndex">
            <ng-container *ngTemplateOutlet="dynamicProp; context: { item: item }"></ng-container>
          </ng-container>
          <div class="sp-form-group col-span-2">
            <label>Observações</label>
            <textarea pTextarea formControlName="observacoes" placeholder="Notas adicionais..." rows="5" class="w-full"></textarea>
          </div>
        </div>
      </section>

       <!-- ═══════════════════════════════════════════════════════════════════
         7. DOCUMENTOS (Obrigatório para Arma e Viatura)
         ═══════════════════════════════════════════════════════════════════ -->
      <section class="form-section option-section" *ngIf="!editMode">
        <div class="form-section-header">
          <i class="ri-folder-2-line"></i> Documentos
          <span class="req" *ngIf="isArma">*</span>
          <span class="opt-label" *ngIf="!isArma">(opcional)</span>
        </div>
        <p class="form-section-description" *ngIf="isArma">Anexe a licença/alvará e a guia de aquisição da arma.</p>
        <p class="form-section-description" *ngIf="isViatura">Anexe a documentação legal da viatura (Livrete, Título de Propriedade, Seguro, etc.).</p>

        <ng-container *ngIf="pendingDocumentos.length">
          <div class="attach-row" *ngFor="let doc of pendingDocumentos; let i = index">
            <span class="attach-label" *ngIf="isArma">
              {{ i === 0 ? "Licença / Alvará" : i === 1 ? "Guia de Aquisição" : "Documento adicional" }}
            </span>
            <span class="attach-label" *ngIf="isViatura">
              {{ i === 0 ? "Livrete / Registro" : i === 1 ? "Título de Propriedade" : i === 2 ? "Seguro da Viatura" : "Documento adicional" }}
            </span>
            <div class="attach-pick" [class.has-file]="doc.file" (click)="docInput.click()">
              <i class="ri-attachment-2" *ngIf="!doc.file"></i>
              <i class="ri-file-check-line" *ngIf="doc.file"></i>
              <span>{{
                doc.file ? doc.file.name : "Clique para seleccionar ficheiro"
                }}</span>
              <input #docInput type="file" hidden (change)="onDocumentoSelect($event, i)" />
            </div>
            <input pInputText class="attach-name" [(ngModel)]="doc.designacao" [ngModelOptions]="{ standalone: true }"
              [placeholder]="isArma && i === 0 ? 'Licença / Alvará' : isArma && i === 1 ? 'Guia de Aquisição' : isViatura && i === 0 ? 'Livrete / Registro' : isViatura && i === 1 ? 'Título de Propriedade' : 'Descrição / nome do documento'" />
            <button type="button" class="btn-icon-sm danger" (click)="removeDocumento(i)" pTooltip="Remover documento"
              tooltipPosition="top">
              <i class="ri-delete-bin-line"></i>
            </button>
          </div>
        </ng-container>

        <div class="attach-empty" *ngIf="!pendingDocumentos.length">
          <i class="ri-folder-open-line"></i>
          <span>Sem documentos adicionados</span>
        </div>

        <small class="form-error" *ngIf="(isArma) && !pendingDocumentos.length">
          Pelo menos um documento é obrigatório para este tipo de equipamento.
        </small>

        <button type="button" class="btn-add-row" (click)="addDocumento()">
          <i class="ri-add-line"></i> Adicionar Documento
        </button>
      </section>

      <!-- ═══════════════════════════════════════════════════════════════════
           8. HISTÓRICO DE MANUTENÇÃO — opcional (não aplicável a Arma)
           ═══════════════════════════════════════════════════════════════════ -->
      <section class="form-section option-section" *ngIf="!editMode && !isArma">
        <div class="form-section-header">
          <i class="ri-tools-line"></i> Histórico de Manutenção
          <span class="opt-label">(opcional)</span>
        </div>

        <ng-container *ngIf="pendingManutencoes.length">
          <div class="manu-card" *ngFor="let m of pendingManutencoes; let i = index">
            <div class="manu-card-header">
              <span class="manu-idx"><i class="ri-tools-line"></i> Manutenção {{ i + 1 }}</span>
              <button type="button" class="btn-icon-sm danger" (click)="removeManutencao(i)" pTooltip="Remover"
                tooltipPosition="top">
                <i class="ri-delete-bin-line"></i>
              </button>
            </div>
            <div class="manu-card-body">
              <div class="form-grid">
                <div class="sp-form-group">
                  <label>Tipo</label>
                  <p-select [(ngModel)]="m.tipo" [ngModelOptions]="{ standalone: true }" [options]="tiposManutencao"
                    optionLabel="label" optionValue="value" styleClass="w-full" />
                </div>
                <div class="sp-form-group">
                  <label>Data</label>
                  <p-datepicker [(ngModel)]="m.data" [ngModelOptions]="{ standalone: true }" dateFormat="dd/mm/yy"
                    [showIcon]="true" [maxDate]="today" appendTo="body" [baseZIndex]="1000010" styleClass="w-full" [autoZIndex]="true" panelStyleClass="drawer-datepicker-panel" />
                </div>
                <div class="sp-form-group">
                  <label>Técnico Responsável</label>
                  <input pInputText [(ngModel)]="m.tecnico" [ngModelOptions]="{ standalone: true }"
                    placeholder="Nome do técnico" class="w-full" />
                </div>
                <div class="sp-form-group">
                  <label>Custo (AOA)</label>
                  <p-inputnumber [(ngModel)]="m.custo" [ngModelOptions]="{ standalone: true }" [minFractionDigits]="0"
                    [maxFractionDigits]="0" styleClass="w-full" placeholder="0" />
                </div>
                <div class="sp-form-group col-span-2">
                  <label>Descrição</label>
                  <textarea pTextarea [(ngModel)]="m.descricao" [ngModelOptions]="{ standalone: true }"
                    placeholder="Descreva o trabalho realizado..." rows="2" class="w-full"></textarea>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <div class="attach-empty" *ngIf="!pendingManutencoes.length">
          <i class="ri-tools-line"></i>
          <span>Sem registos de manutenção adicionados</span>
        </div>

        <button type="button" class="btn-add-row" (click)="addManutencao()">
          <i class="ri-add-line"></i> Registar Manutenção
        </button>
      </section>

      <!-- Aviso modo edição: docs e manutenções geridas no detalhe -->
      <div class="edit-readonly-notice" *ngIf="editMode">
        <div class="ern-icon"><i class="ri-information-line"></i></div>
        <div class="ern-body">
          <strong>Documentos e Manutenções não editáveis aqui</strong>
          <span>Para adicionar ou remover documentos e registos de manutenção,
            utilize a página de detalhe do equipamento.</span>
        </div>
        <a class="ern-link" [routerLink]="['/admin/equipamentos', editId]">
          <i class="ri-arrow-right-line"></i> Ver detalhe
        </a>
      </div>

      <!-- SEÇÃO 5: Observações (Arma) -->
      <section class="form-section" *ngIf="isArma">
        <div class="form-section-header">
          <i class="ri-sticky-note-line"></i> Observações
        </div>
        <p class="form-section-description">Registe informação complementar sobre a arma.</p>
        <div class="form-grid">
          <div class="sp-form-group col-span-2">
            <textarea pTextarea formControlName="observacoes" aria-label="Observações" placeholder="Notas adicionais..." rows="5" class="w-full"></textarea>
          </div>
        </div>
      </section>

      <!-- ACÇÕES -->
      <div class="form-actions">
        <button type="button" class="btn-secondary" (click)="cancel()">
          <i class="ri-close-line"></i> Cancelar
        </button>
        <p-button type="submit" [label]="editMode ? 'Guardar Alterações' : 'Criar Equipamento'" icon="pi pi-save"
          [loading]="loading" [disabled]="loading" />
      </div>
    </form>
  </div>
</div>
